import React, { FC, PropsWithChildren } from 'react';

// Common Dependencies
import { Box, StackLayout, styled } from '@leagueplatform/genesis-core';
import type {
  GDSStackLayoutHorizontalAlignment,
  GDSStackLayoutVerticalAlignment,
} from '@leagueplatform/genesis-core';

// Hooks

// Common Components

// Types

// Constants
import {
  ACTIVITY_CONTENT_BASE_WIDTH,
  TRANSITIONS,
} from '../constants/multi-step-footer-constants';

// Local Types
interface MultiStepLayoutProps {
  horizontalAlignment?: GDSStackLayoutHorizontalAlignment;
  verticalAlignment?: GDSStackLayoutVerticalAlignment;
}

// Local Components
const FullPageHeight = styled(Box, {
  height: '100%',
  inset: 0,
  position: 'absolute',
  backgroundColor: '$surfaceBackgroundTertiary',
});

const ContentPosition = styled(StackLayout, {
  padding: '$oneAndHalf 0',
  paddingTop: '$five',
  transition: `all ${TRANSITIONS.PAGE}`,
  overflow: 'hidden',
});

const ContentWrapper = styled(StackLayout, {
  position: 'relative',
  width: ACTIVITY_CONTENT_BASE_WIDTH,
  maxWidth: '100%',
});

export const MultiStepLayout: FC<PropsWithChildren<MultiStepLayoutProps>> = ({
  children,
  horizontalAlignment = 'center',
  verticalAlignment = 'top',
}) => (
  <FullPageHeight data-testid="multi-step-page">
    <ContentPosition
      data-testid="multi-step-layout"
      orientation="vertical"
      horizontalAlignment={horizontalAlignment}
      verticalAlignment={verticalAlignment}
    >
      <ContentWrapper
        data-testid="multi-step-content-wrapper"
        orientation="vertical"
        horizontalAlignment="center"
      >
        {children}
      </ContentWrapper>
    </ContentPosition>
  </FullPageHeight>
);
